module.exports = __webpack_public_path__ + "img/stage.59a252c6.svg";